import * as Graphql from "@hireroo/graphql/client/urql";
import { CompetitionSearchForm } from "@hireroo/validator";

/**
 * @example
 * ```ts
 * // "ENDED"が選択されている場合、"CONFIRMED"も追加される
 * const statuses = ["CREATED", "STARTED", "ENDED"];
 * const graphqlStatuses = convertStatusFilterToGraphqlStatus(statuses);
 * // graphqlStatuses = [CREATED, STARTED, ENDED, CONFIRMED]
 * ```
 */
export const convertStatusFilterToGraphqlStatus = (
  statuses: CompetitionSearchForm.CompetitionSearchSchema["statuses"],
): Graphql.CompetitionStatus[] => {
  const statusSet = new Set<Graphql.CompetitionStatus>(statuses);

  // ENDEDが選択されている場合、CONFIRMEDも追加する
  if (statusSet.has(Graphql.CompetitionStatus.Ended)) {
    statusSet.add(Graphql.CompetitionStatus.Confirmed);
  }

  return Array.from(statusSet);
};
